import { render, staticRenderFns } from "./MenuItemCollapsed.vue?vue&type=template&id=4ddb4df4&scoped=true&"
import script from "./MenuItemCollapsed.vue?vue&type=script&lang=js&"
export * from "./MenuItemCollapsed.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemCollapsed.vue?vue&type=style&index=0&id=4ddb4df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb4df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2141801166/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ddb4df4')) {
      api.createRecord('4ddb4df4', component.options)
    } else {
      api.reload('4ddb4df4', component.options)
    }
    module.hot.accept("./MenuItemCollapsed.vue?vue&type=template&id=4ddb4df4&scoped=true&", function () {
      api.rerender('4ddb4df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/containers/core/leftNavBar/MenuItemCollapsed.vue"
export default component.exports